export const SET_GALLERY_DATA = '[GALLERY] SET_GALLERY_DATA';
export const FETCH_GALLERY_DATA = '[GALLERY] FETCH_GALLERY_DATA';
export const IS_FETCHING = '[GALLERY] IS_FETCHING';
export const TOGGLE_DISPLAY_ENTRY = '[GALLERY] TOGGLE_DISPLAY_ENTRY';

export const toggleDisplayEntry = (bool) => ({
  type: TOGGLE_DISPLAY_ENTRY,
  payload: bool,
});

import { fetchGalleryData as getData } from 'js/services/api.js';

export const fetchGalleryData = () => {
  return async (dispatch) => {
    dispatch({
      type: IS_FETCHING,
    });
    const data = await getData();

    dispatch({
      type: SET_GALLERY_DATA,
      payload: data.payload,
    });
  };
};

import { enterGalleryData } from 'js/services/api';

export const GALLERY_SUBMISSION_FETCHING = '[GALLERY] GALLERY_SUBMISSION_FETCHING';
export const GALLERY_SUBMISSION_STATUS = '[GALLERY] GALLERY_SUBMISSION_STATUS';

export const submitGalleryEntry = (data, callback) => {
  return async (dispatch) => {
    dispatch({
      type: GALLERY_SUBMISSION_FETCHING,
      payload: true,
    });

    const response = await enterGalleryData(data);

    if (response.result === 'SUCCESS') {
      dispatch({
        type: GALLERY_SUBMISSION_STATUS,
        payload: { status: 'success', message: 'You have successfully submitted your artwork!' },
      });
      callback();
    } else {
      dispatch({
        type: GALLERY_SUBMISSION_STATUS,
        payload: { status: 'failure', message: response.reason },
      });
    }
  };
};

export const clearGallerySubmissionStatus = () => ({
  type: GALLERY_SUBMISSION_STATUS,
  payload: { status: null, message: null },
});
